import { useInfiniteQuery } from '@tanstack/react-query';
import { getCmsRequest, type UserType } from '@tyro/api';
import type { WhatsNewListData } from '../@types/whats-new';
import {
  DEFAULT_WHATS_NEW_PAGE_LIMIT,
  getWhatsNewListPath,
} from '../utils/whats-new-api-paths';
import { shellKeys } from './keys';

export function useWhatsNewList(userType: UserType | undefined) {
  return useInfiniteQuery({
    queryKey: shellKeys.whatsNew.list(userType!),
    initialPageParam: 1,
    queryFn: ({ pageParam }) =>
      getCmsRequest<{ data: WhatsNewListData[] }>(
        getWhatsNewListPath(userType!, pageParam),
      ),
    getNextPageParam: (lastPage, _, lastPageParam) => {
      return lastPage.data.length === DEFAULT_WHATS_NEW_PAGE_LIMIT
        ? lastPageParam + 1
        : undefined;
    },
    enabled: !!userType,
    select: (data) => ({
      ...data,
      pages: data.pages.flatMap(({ data }) => data),
    }),
  });
}
